/**
 * The format in which to show each date in the date range summary
 * on the date pager
 */
export const datePagerFormat = "EEE dd MMM";
